<template>
    <div>
        <el-form :inline="true" ref="formInline" :model="formInline" class="g-search-form">
            <el-form-item label="客户名称">
                <el-input v-model="formInline.customerName" placeholder="客户名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button type="primary" @click="showModal('add');isAdd=true">新增</el-button>
                <el-button type="primary" @click="putIn('put');isAdd=false">投放设备</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :row-class-name="tableRowClassName"
                :data="tableData"
                border
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    fixed
                    prop="customerName"
                    label="客户名称"
            >
            </el-table-column>
            <el-table-column
                    prop="customerPhone"
                    label="联系方式"
            >
            </el-table-column>
            <el-table-column
                    prop="endTime"
                    label="结束时间"
            >
            </el-table-column>
            <el-table-column
                    prop="typeName"
                    label="广告类型"
            >
            </el-table-column>
            <el-table-column
                    prop="remark"
                    label="备注"
            >
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="200">
                <template slot-scope="scope">
                    <el-button @click="editData(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="info(scope.row)" type="text" size="small">投放设备</el-button>
                    <el-button @click="removeData(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="g-pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 200, 300, 400]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNumber">
            </el-pagination>
        </div>
        <el-dialog title="广告信息"
                   v-if="visible"
                   style="text-align: left"
                   :visible.sync="visible">
            <add v-if="isAdd" ref="addForm" :dataId="dataId" @handleCancel="handleCancel" @getList="getList"></add>
            <put :checkData="checkData" ref="putMedia" v-if="!isAdd" @handleCancel="handleCancel"></put>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="handleOk">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import add from "./add"
    import put from "./put"
    import {getMediaDeliveryList, deletlMediaDeliveryDetail} from "../../api/advertisingManagement";

    export default {
        data() {
            return {
                checkData: [],
                isAdd: false,
                expand: false,
                tableData: [],
                visible: false,
                confirmLoading: false,
                dataId: '',
                currentPage: 1,
                totalNumber: 0,
                formInline: {
                    customerName: ''
                }
            }
        },
        watch: {
            dataId() {
                this.visible = false;
                this.$nextTick(() => {
                    this.visible = true;
                })
            }
        },
        created() {
            this.getList()
        },
        computed: {
            count() {
                return this.expand ? 11 : 7;
            },
        },
        methods: {
            /**
             * 获取列表数据
             * ****/
            getList(page = this.currentPage, size = 10) {
                let requestData = {...this.formInline};
                requestData.page=page;
                requestData.size=size;
                getMediaDeliveryList(requestData).then((res) => {
                    this.totalNumber = parseInt(res.data.totalNumber);
                    this.tableData = res.data.listData;
                })
            },
            /**
             * 分页
             * */
            handleSizeChange(val) {
                this.getList(1, val)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList(val)
            },
            /**
             * 搜索
             * */
            handleSearch(e) {
                //冒泡阻止
                e.preventDefault();
                this.$refs['formInline'].validate((valid) => {
                    if (valid) {
                        this.getList(1,10)
                    }
                })
            },
            /**
             * rest搜索表单
             */
            handleReset() {
                this.form.resetFields();
            },
            /**
             * 更多搜索条件
             */
            toggle() {
                this.expand = !this.expand;
            },
            /**
             * 打开model
             */
            showModal(typeClick = '') {
                if (typeClick !== '') {
                    this.dataId = ''
                }
                this.visible = true
            },
            /**
             * model确定按钮
             */
            handleOk() {
                if (!this.isAdd) {
                    this.$refs['putMedia'].submitForm()
                } else {
                    this.$refs['addForm'].submitForm()
                }
            },
            /**
             * 关闭model
             */
            handleCancel() {
                this.isAdd ? this.$refs['addForm'].resetForm() : null;
                this.visible = false
            },
            /**
             * 编辑数据
             * @param rowData
             */
            editData(rowData) {
                this.isAdd = true;
                this.dataId = rowData.id;
                this.visible = true
            },
            tableRowClassName({rowIndex}) {
                if (rowIndex % 2 === 0) {
                    return 'warning-row';
                } else {
                    return '';
                }

            },
            /**
             * 多选表格数据
             * @param data
             */
            handleSelectionChange(data) {
                this.checkData = [];
                data.map(item => {
                    this.checkData.push(item.id)
                })
            },
            putIn() {
                this.visible = true
            },
            info(data) {
                this.isAdd = false;
                this.visible = true;
                this.checkData = [];
                this.checkData.push(data.id)
            },
            removeData(rowData) {
                this.$alert('你确定删除吗？', {
                    confirmButtonText: '确定',
                    callback: (action) => {
                        if (action === 'confirm') {
                            deletlMediaDeliveryDetail({
                                id: rowData.id
                            }).then(() => {
                                this.$message.success("删除成功");
                                this.getList(this.currentPage, 10)
                            })
                        }
                    }
                });
            }
        },
        components: {
            add: add,
            put
        }
    }
</script>
<style scoped>
    .g-pagination {
        text-align: right;
        margin-top: 10px;
    }

</style>
